import React, { useEffect } from "react";

import { Action, Category } from "constants/events";
import { INITIAL_RESULT_LENGTH, SEARCH_INITIAL_TAKE } from "constants/search";
import { useEventTracker } from "hooks/useEventTracker";
import useSearch from "redux/hooks/useSearch";

import ArticleCard, {
  ArticleCardPlaceholder,
} from "components/botanic/ArticleCard";
import SearchViewMoreButton from "components/search/SearchViewMoreButton";

const ArticleResults: React.FC = () => {
  const {
    article,
    loading,
    searchTerm,
    searchCategory,
    loadMoreSearchResults,
  } = useSearch();

  const { publishEvent } = useEventTracker();

  const isCategoryTab = searchCategory === "article";

  useEffect(() => {
    if (isCategoryTab && article.length === SEARCH_INITIAL_TAKE) {
      loadMoreSearchResults("article", 7);
    }
  }, [isCategoryTab]);

  const articles = isCategoryTab
    ? article
    : article.slice(0, INITIAL_RESULT_LENGTH);

  return (
    <>
      <h2>News & culture</h2>
      <p className="mb-lg">matching "{searchTerm}"</p>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {loading
          ? new Array(isCategoryTab ? 8 : INITIAL_RESULT_LENGTH)
              .fill(null)
              .map((_, i) => (
                <ArticleCardPlaceholder
                  key={`article-card-placeholder-${i}`}
                  className="h-full shadow-low rounded bg-white"
                />
              ))
          : articles.map((article) => (
              <ArticleCard
                key={article.id}
                author={article.author}
                date={article.date}
                href={article.relativeLink}
                imageUrl={article.image}
                onClick={() =>
                  publishEvent({
                    action: Action.click,
                    articleId: article.id,
                    category: Category.newsArticleCard,
                    label: article.title,
                  })
                }
                tags={article.tags}
                title={article.title}
              />
            ))}
      </div>

      <SearchViewMoreButton category="article" />
    </>
  );
};

export default ArticleResults;
